import { render, staticRenderFns } from "./ModalAddTask.vue?vue&type=template&id=05da4316&scoped=true"
import script from "./ModalAddTask.vue?vue&type=script&lang=js"
export * from "./ModalAddTask.vue?vue&type=script&lang=js"
import style0 from "./ModalAddTask.vue?vue&type=style&index=0&id=05da4316&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05da4316",
  null
  
)

export default component.exports